import React, { Fragment, useState, useEffect } from 'react'
import { Button, Col, Row } from 'reactstrap';
import { BtnSaveWorkOrder, PlaceHolderOption } from '../../../constant';
import { useWorkOrder } from '../../../hooks/workOrder/useWorkOrder';
import { TableWorkOrder } from '../../../components/elements/TableWorkOrder';
import { ModalViewExams } from '../../../components/workOrders/ModalViewExams';
import { ModalPatient } from '../../../components/patients/ModalPatient';
import { ModalDoctor } from '../../../components/doctors/ModalDoctor';
import { ModalSpecialDiscount } from '../../../components/workOrders/ModalSpecialDiscount';
import { ModalCommonDiscounts } from '../../../components/workOrders/ModalCommonDiscounts';
import { ModalQuoter } from '../../../components/workOrderQuoter/ModalQuoter';
import { ModalRepeatProfile } from '../../../components/workOrders/ModalRepeatProfile';
import { ModalDevolution } from '../../../components/workOrders/ModalDevolution';
import { ModalLiquidacion } from '../../../components/workOrders/ModalLiquidacion';
import { ModalAuthorize } from '../../../components/workOrders/ModalAuthorize';
import { AvailablePayMethodByCompany } from '../../../constant/workOrder';
import { ModalUpdateMethod } from '../../../components/workOrders/ModalUpdateMethod';
import DeniReactTreeView from "deni-react-treeview"
import { ModalCourtesyy } from '../../../components/workOrders/ModalCourtesyy';
import { IndexTypeMicro } from './IndexTypeMicro';
import { ModalMassLoadErrors } from '../../../components/workOrders/ModalMassLoadErrors';
import { ModalListDevolution } from '../../../components/workOrders/ModalListDevolution';
import { useLocation } from "react-router-dom";
import { Dialog } from 'primereact/dialog';
import { IndexSidebar } from './IndexSidebar';
import { IndexHeader } from './IndexHeader';
import { ComponentPatient } from './ComponentPatient';
import { buap, cedimi, insan, pyrsa, labcen, sharp, hsjs, phersu, arcangeles, semlab } from '../../../constant/globalConstantsTypeClients';
import { ComponentDoctors } from './ComponentDoctors';
import { ModalTotalOrder } from '../../../components/workOrders/ModalTotalOrder';
import { ListOptionsPaymentBy, OptionPaymentByCompany, OptionPaymentByPatient } from '../../../constant/workOrder';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { ModalAutorization } from '../../../components/workOrders/ModalAutorization';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { CustomAlertDialogGlobal } from '../../alertDialog/CustomAlertDialogGlobal';
import { ToastAletGlobal } from '../../alertDialog/ToastAletGlobal';
import { DialogHistoricoHospitalized } from './DialogHistoricoHospitalized';
import './styleExams.css';
import './styleFooter.css';
import './StyleDarkAdmission.css';
import './styleSidebar.css';
import './styleComponentPatientAndDoctor.css';
import './styleHeader.css';
import './checkSendWorkOrder.css';
import './styleNewOrder.css';
import './StyleWorkOrder.css';
import 'animate.css';

import { AlertTriangle } from "react-feather";






export const IndexWorkOrder = () => {

    // * CONFIGURATION INDEX


    const location = useLocation();
    const isRegistration = location.pathname.includes("/registro");

    const {

        modalTitle, number_format,

        // ? GLOBAL VAR
        isEditWorkOrder,
        loadingEditWorkOrder,

        //#region WORK ORDER
        // ?VALUES
        checkTypeClient,
        listPrinterPoint, listPayMethod,
        id_patient, id_company, id_printer_point,
        observations, observations_sample, observations_general, checkPrint, checkEmail, checkWhats,
        percentageDiscount, showDiscountWarning, showDiscountWarningPay,
        checkDoctor, checkInvoice, listTest, listPayMethods,
        listCompanies, listAgreements, listType,
        loading,
        subTotalW, totalDiscountW, totalTaxesW, totalW, totalDevolutions,
        showMessageW, showMessageWF, showClass, viewExamsProfile, validationsWorkOrder,
        enableBtnSaveWorkOrder, validationsRepeat, checkComments, ShowClassNameC,
        devolutionsW, isPayForCompany,
        handleBirthDateChange, handleAgeChange,
        idAgreementCompany,

        //FILES PATIENT
        handleOnChange, DeleteFile,

        //METHODS
        handleChangeTypeClient, handleInputChangeWorkOrder, handleDinamicInputWorkOrder, handleSelectValuesWorkOrder,
        handleSelectExamChange,
        removeExamProfile, handleCheckUrgent, handleCheckSpecimen, handleCheckForwarded, handleAddPayMethodInputs, handleGiveChange,
        handleDeletePayMethod, handleViewExamsProfile, saveWorkOrder, cancellWorkOrder,
        saveUpdateWorkOrder, handleChangeExternalLaboratories,
        handleChangeGeneratePay, handleChangeClient, handleChangeAgreement,

        // CONFIGURATION TOTAL
        toggleTotal, modalTotal, handleModalTotal, isPay,

        toggleAlert, showTimeAlert, modalTime,

        //  CONFIGURATION EDIT ORDER
        isSaved, handleSave, modalActions, toggleActionAlert, showActionAlert, changes,
        saveOrder, loadingSaveConfiguration, handleCancelChanges,

        viewLabcen, hasChanges, toasts, enable_whatsapp, enable_tracking_toma, _edit, _adminFinance, url_helen,

        //MODALS WORK ORDER
        toggleModalViewExams, modalViewExamsP, modalRepeatProfile, toggleRepeatProfile, toggleModalDevolutions, modalDevolutions,
        handleCheckEmail, handleCheckDoctor, handleWhatsappChange, validateWhatsapp, checkWhatsdoctor, handleCheckWhatsChange,

        modalDevolution, toggleModalDevolution, getAgeDetail, minDate, handleAutoSave, newQuoter, dataInfo,
        listReturnReason, handleChangeReturnReason, loadingIsDevolution, closeModalPatient, _authorized_movement,
        _branch_name, _service,

        //#endregion

        //#region PATIENT
        //VALUES
        formValuesPatient, listBloodType,
        informationPatient, listStates, listMunicipalities, listTaxRegime, listUseCfdiPatient,
        modalPatient, togglePatient,
        methodPatient, loadingPatient,
        handleInputChangePatient, handleSelectValuesPatient,
        validationsPatient, Listsocialgender,
        isInvoiceService, setIsInvoiceService,
        viewNewSocialGender, setViewNewSocialGender,
        //METHODS
        handleChangePatient,
        handleChangeStatePatient, handleDatePatient,
        handleCreatePatient, saveCreatePatient,
        handleUpdatePatient, saveUpdatePatient,
        handleChangeTypePerson, handleChangeTaxRegime, handleChangeSocialGender,

        // CATALOGS
        listConfiguration, fieldErrors, errors,
        //#endregion

        //#region DOCTOR
        //VALUES
        informationDoctor, workOrderId,
        modalDoctor, toggleDoctor,
        methodDoctor, loadingDoctor, validaciones1,
        handleInputChangeDoctor, nameInputsDoctor, validationsDoctor,
        handleChangeDoctor, specialties,
        id_specialty, name_doctor, professional_license, phone_doctor,
        address_doctor, email_doctor, name_specialty, isCommercialPartner,
        code, listSellers, generateRandomPassword, username, password_microsite, id_seller, whatsapp_doctor,

        //METHODS
        handleCreateDoctor, saveCreateDoctor,
        handleUpdateDoctor, saveUpdateDoctor, handleSaveDoctor,

        // ? DOCTOR
        modalDoctorN,
        toggleDoctorAlert,
        showDoctorAlert,
        titleDoctor,
        modalDoctorDelete,
        toggleDoctorDelete,
        showDoctorDelete,
        confirmDeleteDoctor,
        nameDoctorD,

        // ?  WHATSAPP DOCTOR
        handleCheckWhatsDoctorChange,
        handleWhatsappDoctorChange,
        validateWhatsappDoctor,
        handleCleanDoctor,
        idDoctorSelect,



        //#endregion


        // ? SPECIAL DISCOUNT, COMMONT DISCOUNTS AND ID PRELOAD DISCOUNT
        specialDiscount,
        special_discount_code,
        handleInputChangeSpecialDiscount,
        handleModalSpecialDiscount,
        validateCodeSpecialDiscount,
        modalSpecialDiscounts,
        toggleSpecialDiscount,
        arrayCommonDiscounts,
        handleModalListCommonDiscounts,
        clearDiscount,
        removeExamProfileByCampaign,
        modalCommonDiscount,
        toggleCommonDiscount,
        validatePercentajeSpecialDiscount,
        percentage,
        validateCommonDiscountDetail,
        setValidateCommonDiscountDetail,
        validPorcentejeSpecial,
        newDiscount,
        dataPreloaded,
        handleSelectValuesPreloadedDiscounts,
        id_preloaded_discount,
        validatePreloadedDiscount,
        handleApply,
        listCampaigns,
        selectedCampaign,
        handleChangeCampaign,
        saveStudyDelivery,
        handleApplySanitary,


        // ? QUOTER
        loadingQuoter,
        code_quoter,
        validationsQuoter,
        date_quoter,
        handleInputChangeQuoter,
        listQuoter,
        enableViewTest,
        viewTestQuoter,
        handleGetQuoter,
        handleSearchQuoter,
        searchQuoterByCode,
        handleViewTest,
        handleCloseViewTest,
        modalQuoter,
        toggleModalQuoter,
        methodQuoter,
        id_work_order_type_service,
        enableComments,

        // ? SCAN INE
        setScan_ine_check,
        handleOnChangeINE,
        DeleteINE,
        showClassINE,
        handleOnChangeINEU,


        // ? INVOICE
        requiere_invoice_patient_update,


        // ? DEVOLUTION
        listDevolutions,
        handleChangeDevolution,
        handleCancelDevolution,
        validateDevolutions,
        saveDevolution,

        // ? PAYMENT BILLS
        modalPayBills,
        toggleModalPayBills,
        id_method_liquided,
        amount_liquided,
        id_method_pay,
        amount_liq,
        handleInputChangePaymentBills,
        validationsPaymentBills,
        handlePayBill,
        savePaymentBill,
        study_delivery,
        validTotalCredit,
        validatePassword,
        aunthentication,
        validatePasswordCancell,
        validatePasswordFinance,
        loadingPayment,
        loadingUpdateMethod,
        nim_Notification,
        handleAgeC,
        handleDateB,

        // ? CANCEL WORK ORDER
        modalCancelWorkOrderUpdate,
        toggleModalCancellWorkOrderUpdate,
        user_authorize,
        password_authorize,
        id_return_reason_woc,
        percentage_return,
        handleInputChangeCancelWorkOrder,
        totalCancellationWorkOrder,
        validationsCancelWorkOrder,
        handleCancelWorkOrderUpdate,
        handleValidateReturnAmount,
        saveCancelWorkOrderUpdate,

        // ? DOCTORS
        getAge,
        getBirthday,
        handleWheel,
        doctList,
        handleDeleteDoctor,
        validHopitalInterfaced,

        // ?MODAL PAY METHOD
        modalPreviewUpdate,
        toggleModalUpdate,
        handleUpdateMethod,

        // ? UPDATE METHOD
        user_method,
        user_password_method,
        id_pay_method_method,
        handleInputChangeMethod,

        // ? SAVE PAY METHOD
        saveUpdateMethod,

        // ? VALID BUTTON
        validButton,

        // ? CONFIGURATION ROLES FINANCE
        configuration_role,
        modalAutorization,
        toggleModalAutorization,
        handleCancelAutorization,
        handleSendNotificationInvoices,

        // ? INDICATIONS EXAMS
        treeviewRef,
        itemsTree,

        // ? COURTESY
        ModalCourtesy,
        toggleCourtesy,
        handleCourtesy,
        validatePasswordCortesy,


        // ? CONFIGURATION MICRO
        is_micro,
        informationSampling,
        valueTax,
        downloadQuoter,
        validate_actions,
        _config_dashboard,
        allExams,
        modalUpdateSample,
        toggleModalUpdateSample,
        handleEdit,
        formMic,
        handleChangeSample,
        saveUpdateSampling,
        listSample,
        handleSample,
        saveUpdateChangeSampling,
        listSite,
        handleEditSite,
        toggleModalUpdateSite,
        modalUpdateSite,
        handleChangeSite,
        saveUpdateSite,
        handleSite,
        saveUpdateChangeSite,
        _authorized_sanitary,
        closeModalDoctor,
        editObservation,
        toggleModalUpdateObservation,
        modalUpdateObservation,
        handleChangeObservation,
        saveUpdateObservation,
        deleteSamplingOrder,
        modalSample,
        toggleModalSample,
        handleDeleteSample,

        // ? Massive Load
        massiveLoad,
        handleFileUpload,
        toggleModalErrorMasiveLoad,
        modalOpen,
        handleDeleteMassive,
        massiveSamplig,
        goNextPage,
        goPreviousPage,
        goToPage,
        actualPage,
        totalPages,
        fileReport,
        downloadMassiveSampligFile,
        handleDownload,

        // ? BONUSES

        loadingDevolution,
        historicDevolution,
        amountDevolution,
        demo,
        handleListDevolution,


        // ? COMPANY
        acceptCompany,
        setAcceptCompany,


        // ? BLOCK WORK ORDER
        showPayAlert,
        modalAlert,
        tittleAgreement,
        isEditA,


        // ? CONFIGURATION DETERMINATIONS
        handleListDet5erminations,
        toggleModalDeterminations,
        dataDetermination,
        modalAddDeterminations,
        newDeterminations,
        removeTestFromWorkOrder,
        sampleSelected,
        saveDeterminations,
        loadingAddDeterminations,
        previewDetermination,
        togglePreviewD,
        searchExamProfileState,
        validRestrictCompany,
        _valid_url,


        // ? HISTORIC WORK ORDER
        fech_create_order,
        name_create_order,
        handleViewHistoric,
        modalHistoricOrder,
        toggleHistoric,
        dataHistorical,


        // ? FILES PREVIEW
        onSelect,
        onClear,
        form,
        setForm,
        showEvidence,
        setShowEvidence,
        evidenceFile,
        setEvidenceFile,
        isPdf,
        isImage,
        preview,
        type,
        validate_update_payMethod,

        // ? NEW AMOUNT WORK ORDER
        id_branch,
        new_price,
        validatePriceWorkOrder,

        // ? VALIDATION INSAN
        _active_returnStudies,

        //? CUSTOM ALERT
        customAlert,

        //? TOAST ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        closeToastAlert,
        hospitalization_comment,

        // ? HISTORICO HOSPITALIZACIONES
        dataHistoricalHospitality,
        modalHistoricHospitality,
        toggleHistoricHospitality,
        handleViewHistoricHospitality,
        isInvoicePatient,
        handleHospitalizedChange,

        // ? ORDER MEDICAL 
        valid_medical_order,
        showMedicalOrderPreview, setShowMedicalOrderPreview, evidenceBody, openEvidence,
        openDeleteMedicalConfirm,
        showDeleteMedicalConfirm, setShowDeleteMedicalConfirm,
        handleDeleteMedical,
        loadingDelete, clearVariables






    } = useWorkOrder();

    useEffect(() => {
        if (!is_micro && !isEditWorkOrder) {
            clearVariables();
        }
    }, [is_micro]);



    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };




    // * CONFIGURATION
    const [modalStudies, setModalStudies] = useState(false);
    const hasFile = showMessageWF.labelWF.includes("Cargada");
    var _total_Bonusses = 0;
    const showButton = validPorcentejeSpecial === labcen;
    const currentTest = listTest[0];
    const [rightPanelOpen, setRightPanelOpen] = useState(false);
    const [showDoctorDialog, setShowDoctorDialog] = useState(false);
    const [selectedDoctor, setSelectedDoctor] = useState(null);

    // * CONFIGURATION DISCOUNT
    const [isPreloadedApplied, setIsPreloadedApplied] = useState(false);
    const [isCodeApplied, setIsCodeApplied] = useState(false);
    const [isPercentageApplied, setIsPercentageApplied] = useState(false);

    // * HISTORIC PATIEN
    const methodBody = (rowData) => {

        let color = "";
        let icon = "";
        let text = "";

        switch (rowData.method?.toUpperCase()) {

            case "ACTUALIZAR":
                color = "badge-update";
                icon = "pi pi-pencil";
                text = "Actualizar";
                break;

            case "ELIMINAR":
                color = "badge-delete";
                icon = "pi pi-trash";
                text = "Eliminar";
                break;

            case "CREAR":
            case "INSERTAR":
                color = "badge-create";
                icon = "pi pi-plus-circle";
                text = "Crear";
                break;

            default:
                color = "badge-default";
                icon = "pi pi-history";
                text = rowData.method;
                break;
        }

        return (
            <span className={`historic-badge ${color}`}>
                <i className={icon}></i>
                <span>{text}</span>
            </span>
        );
    };


    const toggleStudies = () => {
        setModalStudies(!modalStudies);
    };

    const onRenderItem = (item) => {

        const icon = item.isLeaf
            ? <i className='icofont icofont-prescription'></i>
            : <img
                alt="flask"
                src={require("../../../assets/images/typeService.svg")}
                style={{ width: "16px", height: "16px" }}
            />;

        const color =
            item.state === 1 ? "#ff9817" :
                item.state === 2 ? "#94a3b8" :
                    item.state === 3 ? "#334155" :
                        item.state === 4 ? "#7dd3fc" :
                            "#cbd5e1";

        const className = item.state === 1
            ? "tree-item-custom with-bg tittleCollapseE"
            : "tree-item-custom tittleCollapseE";

        return (
            <div className={className} style={{ width: "100%" }}>
                <span className="tree-icon">{icon}</span>

                <span
                    className="tree-text tittleCollapseE"
                    style={{ color }}
                    title={item.text}
                >
                    {item.text}
                </span>
            </div>
        );
    };


    const {
        listPayMethods_valid,
        listid,
    } = validationsWorkOrder;


    // * CONFIGURATION SELECT DARK
    const customSelectStyles = {
        input: (base) => ({
            ...base,
            color: "#fff"
        }),
        control: (base) => ({
            ...base,
            background: "rgba(255,255,255,0.05)",
            borderRadius: "20px",
            border: "1px solid rgba(255,255,255,0.08)",
            minHeight: "34px",
            fontSize: "11px",
            boxShadow: "none"
        }),

        menu: (base) => ({
            ...base,
            background: "#0f172a",
            borderRadius: "10px",
            padding: "4px",
            border: "1px solid rgba(255,255,255,0.08)"
        }),

        option: (base, state) => ({
            ...base,
            background: state.isSelected
                ? "#2563eb"
                : state.isFocused
                    ? "rgba(37,99,235,0.2)"
                    : "transparent",
            color: state.isSelected ? "#fff" : "#fefefe",
            fontSize: "11px",
            borderRadius: "6px",
            cursor: "pointer"
        }),

        singleValue: (base) => ({
            ...base,
            color: "#fff"
        }),

        placeholder: (base) => ({
            ...base,
            color: "#94a3b8"
        }),

        dropdownIndicator: (base) => ({
            ...base,
            color: "#94a3b8"
        }),

        indicatorSeparator: () => ({
            display: "none"
        })
    };

    // * CONFIGURATION DISCOUNT
    const handleApplyPreloaded = () => {
        validatePreloadedDiscount();
        setIsPreloadedApplied(true);
    };

    const handleApplyCode = () => {
        validateCodeSpecialDiscount();
        setIsCodeApplied(true);
    };

    const handleApplyPercentage = () => {
        validatePercentajeSpecialDiscount();
        setIsPercentageApplied(true);
    };


    const isAnyApplied = isCodeApplied || isPercentageApplied || isPreloadedApplied;

    useEffect(() => {

        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setRightPanelOpen(false);
            }
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);

    }, []);

    const [footerOpen, setFooterOpen] = useState(false);


    const customSelectStyles1 = {
        input: (base) => ({
            ...base,
            color: "#2a6084"
        }),
        control: (base) => ({
            ...base,
            background: "rgba(255,255,255,0.05)",
            borderRadius: "20px",
            border: "1px solid rgba(36, 127, 238, 0.64)",
            minHeight: "34px",
            fontSize: "11px",
            boxShadow: "none"
        }),

        menu: (base) => ({
            ...base,
            background: "#cbd1e1",
            borderRadius: "10px",
            padding: "4px",
            border: "1px solid rgba(255,255,255,0.08)"
        }),

        option: (base, state) => ({
            ...base,
            background: state.isSelected
                ? "#2780bc"
                : state.isFocused
                    ? "rgba(37,99,235,0.2)"
                    : "transparent",
            color: state.isSelected ? "#fff" : "#fefefe",
            fontSize: "11px",
            borderRadius: "6px",
            cursor: "pointer"
        }),

        singleValue: (base) => ({
            ...base,
            color: "#136783"
        }),

        placeholder: (base) => ({
            ...base,
            color: "#94a3b8"
        }),

        dropdownIndicator: (base) => ({
            ...base,
            color: "#94a3b8"
        }),

        indicatorSeparator: () => ({
            display: "none"
        })
    };


    return (
        <Fragment>
            {
                // ! CONFIGURATION GLOBAL MICRO
                is_micro && <IndexTypeMicro
                    {
                    ...{
                        checkTypeClient, informationPatient, id_company, informationSampling, nim_Notification, listTest, handleCancelWorkOrderUpdate,
                        number_format, totalW, listPayMethods, handleDinamicInputWorkOrder, validTotalCredit, AvailablePayMethodByCompany, _adminFinance,
                        handleGiveChange, handlePayBill, handleDeletePayMethod, isEditWorkOrder, isPayForCompany,
                        listPayMethods_valid, showMessageW, subTotalW, totalDiscountW, totalTaxesW, totalDevolutions, listPayMethod, valueTax, downloadQuoter,
                        checkInvoice, deleteSamplingOrder, modalSample, toggleModalSample, handleDeleteSample, dataInfo, listReturnReason, handleChangeReturnReason,
                        loadingIsDevolution, validPorcentejeSpecial,

                        // ? CONFIGURATION UPDATE SAMPLE
                        modalUpdateSample, toggleModalUpdateSample, handleEdit, formMic, handleChangeSample, saveUpdateSampling,
                        listSample, handleSample, saveUpdateChangeSampling,
                        listSite, handleEditSite, toggleModalUpdateSite, modalUpdateSite, handleChangeSite,
                        saveUpdateSite, handleSite, saveUpdateChangeSite, _authorized_sanitary,

                        // * CONFIGURATION OBSERVATION
                        editObservation, toggleModalUpdateObservation, modalUpdateObservation, handleChangeObservation, saveUpdateObservation,
                        // ? CONFIGURATION DETERMINATIONS
                        searchExamProfileState,
                        handleSelectExamChange,
                        validRestrictCompany,
                        _valid_url,
                        newDeterminations, removeTestFromWorkOrder, sampleSelected,
                        errors,
                        saveDeterminations,
                        loadingAddDeterminations,
                        previewDetermination, togglePreviewD,
                        handleListDet5erminations,
                        toggleModalDeterminations,
                        dataDetermination,
                        modalAddDeterminations,
                        handleChangeTypeClient,

                        //* delivery date
                        minDate,
                        handleApply,
                        handleAutoSave,
                        study_delivery,
                        saveStudyDelivery,
                        handleApplySanitary,

                        // * HISTÓRICO
                        handleViewHistoric,
                        dataHistorical
                    }

                    }
                />
            }
            {
                // ! CONFIGURATION CLINICOS
            }
            {
                !is_micro && <div className="pos-container">

                    {/* HEADER */}
                    <header className="pos-header">
                        <IndexHeader
                            {
                            ...{

                                // * MOVILE CONFIGURATION
                                rightPanelOpen,
                                setRightPanelOpen,

                                // * CONTROL ACTIONS
                                id_printer_point,
                                listPrinterPoint,
                                handleSelectValuesWorkOrder,
                                PlaceHolderOption,
                                handleChangeTypeClient,
                                checkTypeClient,
                                handleChangePatient,
                                handleChangeDoctor,
                                id_company,
                                handleChangeClient,
                                idAgreementCompany,
                                handleChangeAgreement,
                                id_work_order_type_service,
                                isEditWorkOrder,

                                // * INFORMATION LISTS
                                listCompanies,
                                listAgreements,
                                validHopitalInterfaced,
                                listType,

                                // * LOCAL STORAGE
                                _service,

                                // * STYLES
                                customSelectStyles,

                                idDoctorSelect,
                                handleSelectExamChange,

                                // * UPLOAD
                                url_helen,
                                buap,

                                // * GLOBAL SEARCH
                                handleCreateDoctor,
                                handleCreatePatient,
                                id_patient,
                                _config_dashboard,
                                validate_actions,
                                allExams,
                                loadingEditWorkOrder,

                                // * EDIT WORK ORDER
                                handleCancelWorkOrderUpdate,
                                customSelectStyles1,

                            }
                            }
                        />
                    </header>

                    {/* BODY */}
                    <div className="pos-body">

                        {/* MAIN */}
                        <div className="pos-main">
                            {
                                // ! MESSAGE CREATE ORDER
                            }
                            {
                                (informationPatient?.name === null && checkTypeClient !== 2 && !isEditWorkOrder) &&
                                <Col sm="12" className='pt-5' style={{ textAlign: "center", position: "relative", overflow: "hidden" }} >

                                    <div className="floating-circles">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>

                                    <i className="fa fa-receipt pos-empty-icon"></i> <br /><br /><br /><br /><br /><br />

                                    <i className="icofont icofont-document-search pos-empty-icon-a"></i> <br /><br />


                                    <h6 className="pos-empty-title">
                                        INGRESE LOS ESTUDIOS DEL PACIENTE
                                    </h6>
                                </Col>
                            }
                            {
                                // ! MESSAGE UPDATE ORDER
                            }

                            {
                                (informationPatient?.name === null && checkTypeClient !== 2 && isEditWorkOrder) && (
                                    <Col
                                        sm="12"
                                        className='pt-5'
                                        style={{
                                            textAlign: "center",
                                            position: "relative",
                                            overflow: "hidden"
                                        }}
                                    >

                                        {loadingEditWorkOrder && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    background: "rgba(255,255,255,0.7)",
                                                    backdropFilter: "blur(4px)",
                                                    zIndex: 10,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderRadius: "12px"
                                                }}
                                            >
                                                <i
                                                    className="pi pi-spin pi-spinner"
                                                    style={{
                                                        fontSize: "3rem",
                                                        color: "#1d5b83"
                                                    }}
                                                ></i>

                                                <span
                                                    style={{
                                                        marginTop: "10px",
                                                        fontWeight: "600",
                                                        color: "#1d5b83"
                                                    }}
                                                >
                                                    Cargando orden...
                                                </span>
                                            </div>
                                        )}

                                        {/* 🔹 CONTENIDO NORMAL */}
                                        <div className="floating-circles">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>

                                        <i className="fa fa-receipt pos-empty-icon"></i>

                                        <h5 className="pos-empty-title">
                                            Cargando información de la orden de trabajo...
                                        </h5>

                                        <img
                                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                            style={{ width: "50%", maxWidth: "400px" }}
                                            alt="Sin Muestras"
                                        />

                                    </Col>
                                )
                            }
                            {
                                // * PATIENT AND DOCTOR COMPONENT
                            }
                            <div className="pos-main-fixed">
                                <ComponentPatient
                                    {...{

                                        // * INFORMATION GENERAL
                                        informationPatient,
                                        getAgeDetail,
                                        url_helen,
                                        buap,
                                        handleUpdatePatient,
                                        pyrsa,
                                        _edit,

                                        // * QUOTER
                                        newQuoter,
                                        isEditWorkOrder,
                                        handleSearchQuoter,

                                        // * UPLOAD MEDICAL ORDER
                                        showMessageWF,
                                        handleOnChange,
                                        DeleteFile,
                                        showClass,
                                        hasFile,

                                        // * UPLOAD MASSIVE
                                        checkTypeClient,
                                        handleDownload,
                                        handleFileUpload,
                                        massiveLoad,
                                        massiveSamplig,
                                        toggleModalErrorMasiveLoad,
                                        handleDeleteMassive,

                                        nim_Notification,
                                        hospitalized: informationPatient?.hospitalized,
                                        valid_medical_order,

                                        setShowMedicalOrderPreview,
                                        showMedicalOrderPreview

                                    }}
                                />
                            </div>

                            <div className="pos-main-scroll">
                                {
                                    // * CONFIGURATION DOCTORS
                                }
                                {
                                    (informationPatient?.name !== null || checkTypeClient === 2) && <ComponentDoctors
                                        {
                                        ...{
                                            // * INFO DOCTORS
                                            informationDoctor,
                                            isRegistration,
                                            handleSaveDoctor,
                                            workOrderId,
                                            handleUpdateDoctor,
                                            handleDeleteDoctor,
                                            isEditWorkOrder,
                                            doctList,
                                            url_helen,
                                            cedimi,
                                            handleCleanDoctor
                                        }
                                        }
                                    />
                                }
                                {
                                    // * CONFIGURATION EXAMS
                                }
                                <Col sm="12" className={listTest.length > 0 ? 'pt-2 p-l-0 p-r-0 pt-4' : "d-none"} >
                                    <Row>
                                        <Col sm="8">
                                            <div className='table-responsive'>
                                                {
                                                    listTest.length > 0 && (
                                                        <TableWorkOrder
                                                            key="tableExams"
                                                            items={listTest}
                                                            isEdit={isEditWorkOrder}
                                                            count={listTest.length}
                                                            {...{
                                                                removeExamProfile,
                                                                handleCheckUrgent,
                                                                handleCheckSpecimen,
                                                                handleCheckForwarded,
                                                                number_format,
                                                                handleViewExamsProfile,
                                                                checkTypeClient,
                                                                listid,
                                                                enable_tracking_toma,
                                                                removeExamProfileByCampaign,
                                                                handleChangeExternalLaboratories,
                                                                validate_actions,
                                                                _config_dashboard,
                                                                allExams,
                                                                validPorcentejeSpecial,
                                                                cedimi,
                                                                demo,
                                                                _active_returnStudies,
                                                                semlab

                                                            }}
                                                        />
                                                    )
                                                }
                                            </div>
                                        </Col>
                                        <Col sm="4" className='p-l-0 hide-mobile-actions '>
                                            <div className="section-header">
                                                <i className="fa fa-list-ul"></i>
                                                <span>Indicaciones</span>
                                            </div>
                                            <div className='pt-1 custom-tree'>
                                                {itemsTree && itemsTree.length > 0 ? (
                                                    <DeniReactTreeView
                                                        key={JSON.stringify(itemsTree)}
                                                        ref={treeviewRef}
                                                        style={{
                                                            marginRight: '1px',
                                                            marginBottom: '11px',
                                                            width: "100%"
                                                        }}
                                                        showCheckbox={false}
                                                        showIcon={false}
                                                        items={itemsTree}
                                                        onRenderItem={onRenderItem}
                                                    />
                                                ) : (
                                                    <label className='txt-danger f-w-500'>
                                                        <i className="fa fa-warning"></i> Sin indicaciones previas de estudios
                                                    </label>

                                                )}
                                            </div>
                                        </Col>

                                    </Row >
                                </Col >
                                {
                                    // * END CONFIGURATION
                                }
                            </div >

                        </div >


                        {/* SIDEBAR */}
                        < aside className={`pos-sidebar ${rightPanelOpen ? "open" : ""}`}>
                            <div
                                className="sidebar-hamburger right icon-toggle"
                                onClick={() => setRightPanelOpen(false)}
                            >
                                <i className="fa fa-bars f-18"></i>
                            </div>

                            <div className={`sidebar-content ${(!informationPatient?.name && checkTypeClient !== 2) ? "blocked" : ""}`}>

                                <div className="sidebar-content pt-0">
                                    <IndexSidebar {...{
                                        handleInputChangeWorkOrder,
                                        checkPrint,
                                        checkEmail,
                                        handleCheckEmail,
                                        handleCheckWhatsChange,
                                        checkWhats,
                                        checkDoctor,
                                        handleCheckDoctor,
                                        checkWhatsdoctor,
                                        handleCheckWhatsDoctorChange,
                                        enable_whatsapp,
                                        observations,
                                        observations_sample,
                                        informationDoctor,
                                        minDate,
                                        handleApply,
                                        handleAutoSave,
                                        study_delivery,
                                        checkComments,
                                        enableComments,
                                        observations_general,
                                        ShowClassNameC,
                                        enable_tracking_toma,
                                        isSaved,
                                        customSelectStyles1,
                                        id_printer_point,
                                        listPrinterPoint,
                                        handleSelectValuesWorkOrder,
                                        PlaceHolderOption,
                                        isEditWorkOrder,
                                        handleViewHistoric,
                                        dataHistorical,
                                        hospitalized: informationPatient?.hospitalized,
                                        hospitalization_comment,
                                        dataHistoricalHospitality,
                                        handleViewHistoricHospitality,
                                        handleHospitalizedChange
                                    }} />
                                </div>

                            </div>
                        </aside >
                    </div >

                    {/* FOOTER */}
                    < div
                        className="footer-hamburger mobile-only"
                        onClick={() => setFooterOpen(prev => !prev)}
                    >
                        <i className="fa fa-usd"></i>
                    </div >

                    <div className={`footer-wrapper ${footerOpen ? "open" : ""}`}>
                        <footer className="pos-footer">

                            <div className="footer-stats">

                                {
                                    isEditWorkOrder && (
                                        <Col className={`footer-right ${!informationPatient?.name ? "blocked" : ""}`}>
                                            <div className="footer-study-cancell" onClick={handleCancelWorkOrderUpdate}>
                                                <i className="fa fa-times-circle"></i>
                                                <span>Cancelar</span>
                                            </div>

                                            {
                                                validPorcentejeSpecial === labcen && (
                                                    <div
                                                        className="footer-study-cancell btn-descuentos"
                                                        onClick={() => handleModalSpecialDiscount(true)}
                                                    >
                                                        <span>Descuento</span>
                                                    </div>
                                                )
                                            }
                                        </Col>
                                    )
                                }

                                {/* 🔥 DISCOUNTS */}
                                {
                                    (id_company === 0 || id_company === "0" || id_company === null || id_company === "") &&
                                    //(currentTest && !currentTest.is_urgent) && (
                                    ((currentTest && !currentTest.is_urgent) || listCampaigns.length > 0) && (

                                        < div
                                            className={`discount-col ${isEditWorkOrder ? "d-none" : ""}`}

                                        >

                                            <div className="discount-wrapper">

                                                {
                                                    (arrayCommonDiscounts.length > 0 || (validPorcentejeSpecial === labcen && !isAnyApplied)) && (
                                                        <div>
                                                            <button
                                                                className="btn-discount applied"
                                                                hidden={isEditWorkOrder}
                                                                onClick={handleModalListCommonDiscounts}
                                                            >
                                                                {
                                                                    arrayCommonDiscounts.length > 0 &&
                                                                        !validateCommonDiscountDetail
                                                                        ? <i className="fa fa-tag"></i>
                                                                        : <i className="fa fa-check"></i>
                                                                }

                                                                {
                                                                    arrayCommonDiscounts.length > 0 &&
                                                                        !validateCommonDiscountDetail
                                                                        ? "Candidato a campaña"
                                                                        : "Campaña aplicada"
                                                                }
                                                            </button>
                                                        </div>
                                                    )
                                                }

                                                {
                                                    (arrayCommonDiscounts.length > 0 && validPorcentejeSpecial === labcen && !validateCommonDiscountDetail) && (
                                                        <div>
                                                            {
                                                                specialDiscount === null && (
                                                                    <button
                                                                        className={`${(((id_preloaded_discount !== 0 &&
                                                                            id_preloaded_discount !== null) &&
                                                                            id_preloaded_discount.quoter === true) &&
                                                                            newQuoter)
                                                                            ? "d-none"
                                                                            : "btn-discount"
                                                                            } ${isAnyApplied ? "applied" : ""}`}
                                                                        hidden={isEditWorkOrder}
                                                                        disabled={checkTypeClient === 1 ? false : true}
                                                                        onClick={() => handleModalSpecialDiscount()}
                                                                    >
                                                                        <i className={`fa ${isAnyApplied ? "fa-check" : "fa-tag"}`}></i>
                                                                        {isAnyApplied ? "Aplicado" : (listCampaigns.length > 0 ? "Descuentos / Campañas" : "Descuento")}
                                                                    </button>
                                                                )
                                                            }

                                                        </div>
                                                    )
                                                }

                                                {
                                                    (arrayCommonDiscounts.length === 0) && (
                                                        <div>
                                                            {
                                                                specialDiscount === null ? (
                                                                    <button
                                                                        className={`${(((id_preloaded_discount !== 0 &&
                                                                            id_preloaded_discount !== null) &&
                                                                            id_preloaded_discount.quoter === true) &&
                                                                            newQuoter)
                                                                            ? "d-none"
                                                                            : "btn-discount"
                                                                            } ${isAnyApplied ? "applied" : ""}`}
                                                                        hidden={isEditWorkOrder}
                                                                        disabled={checkTypeClient === 1 ? false : true}
                                                                        onClick={() => handleModalSpecialDiscount()}
                                                                    >
                                                                        <i className={`fa ${isAnyApplied ? "fa-check" : "fa-tag"}`}></i>
                                                                        {isAnyApplied ? "Aplicado" : (listCampaigns.length > 0 ? "Descuentos / Campañas" : "Descuento")}
                                                                    </button>
                                                                ) : (
                                                                    validPorcentejeSpecial === cedimi && (
                                                                        <button
                                                                            className={`btn-discount ${isAnyApplied ? "applied" : ""}`}
                                                                            hidden={isEditWorkOrder}
                                                                            disabled={checkTypeClient === 1 ? false : true}
                                                                            onClick={() => handleModalSpecialDiscount()}
                                                                        >
                                                                            <i className={`fa ${isAnyApplied ? "fa-check" : "fa-tag"}`}></i>
                                                                            {isAnyApplied ? "Aplicado" : "Descuento"}
                                                                        </button>
                                                                    )
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                }

                                                {
                                                    isAnyApplied && (
                                                        <div className="discount-legend">
                                                            <i className="fa fa-info-circle"></i>
                                                            <span>
                                                                {isCodeApplied && "Código promocional aplicado"}
                                                                {isPercentageApplied && `Descuento del ${percentage}% aplicado`}
                                                                {isPreloadedApplied && (
                                                                    <span>
                                                                        {id_preloaded_discount?.label}
                                                                        {` (${id_preloaded_discount?.valuePercentage}%)`}
                                                                    </span>
                                                                )}
                                                            </span>
                                                        </div>
                                                    )
                                                }

                                            </div>

                                        </div>
                                    )
                                }

                                {/* 🔥 TOTALES */}
                                <div className="footer-stats">

                                    <div className="stat">
                                        <span>SUBTOTAL</span>
                                        <strong>$ {number_format(subTotalW, 2)}</strong>
                                    </div>

                                    <div className={(id_company === 0 || id_company === "0") ? "stat" : "d-none"}>
                                        <span>DESCUENTO</span>
                                        <strong>$ {number_format(totalDiscountW, 2)}</strong>
                                    </div>

                                    <div className="stat">
                                        <span>IVA (16%)</span>
                                        <strong>$ {number_format(totalTaxesW, 2)}</strong>
                                    </div>

                                    <div className="footer-total">
                                        <span className="total-label">TOTAL</span>
                                        <strong>$ {number_format(_total_Bonusses ? _total_Bonusses : totalW, 2)}</strong>
                                    </div>

                                </div>

                            </div>

                            {
                                // * CONFIGURATION  TOTAL ORDER
                            }
                            <div className={`footer-right ${!informationPatient?.name ? "blocked" : ""}`}>
                                {id_company?.value && (
                                    <div className="footer-chip success">
                                        <i className="fa fa-credit-card"></i>
                                        <span>
                                            Pago:
                                            {
                                                id_company?.value && isPayForCompany && <b className=''>La empresa</b>
                                            }
                                            {
                                                id_company?.value && !isPayForCompany && !isPay && <b className=''>El paciente</b>
                                            }
                                            {
                                                id_company?.value && !isPayForCompany && isPay && <b className=''>Ambas partes</b>
                                            }
                                        </span>
                                    </div>
                                )}


                                {id_company?.value && (
                                    <div className="footer-chip info">
                                        <span className="chip-icon">
                                            <i className="pi pi-file-pdf "></i>
                                        </span>
                                        <span>
                                            {id_company?.require_invoice && "Factura: Empresa"}
                                            {!id_company?.require_invoice && id_company?.available_invoice_patient && "Factura: Paciente (opcional)"}
                                            {!id_company?.require_invoice && !id_company?.available_invoice_patient && !requiere_invoice_patient_update && "Sin factura"}
                                            {isEditWorkOrder && requiere_invoice_patient_update && "Paciente solicitó factura"}
                                        </span>
                                    </div>
                                )}
                            </div>



                            {/* RIGHT */}
                            <div className={`footer-right ${!informationPatient?.name ? "blocked" : ""}`}>
                                {
                                    amountDevolution !== 0 && <div className="footer-devolution pointer" onClick={handleListDevolution} >

                                        <i className="pi pi-wallet"></i>


                                        <span>Devoluciones</span>
                                    </div>
                                }

                                <div className="footer-study-count">
                                    <span className="badge-count">{listTest.length}</span>
                                    <span>{listTest.length === 1 ? "Estudio" : "Estudios"}</span>
                                </div>

                                {
                                    !hasChanges ? (
                                        <Button
                                            disabled={listTest.length === 0}
                                            className="btn-pay"
                                            onClick={handleModalTotal}
                                        >
                                            Cobrar ahora <i className="pi pi-chevron-right"></i>
                                        </Button>
                                    ) : (
                                        <Button className="btn-pay" onClick={handleSave}>
                                            Actualizar ahora <i className="pi pi-chevron-right"></i>
                                        </Button>
                                    )
                                }

                            </div>

                        </footer>
                    </div>

                </div >
            }
            <ModalPatient
                {
                ...{
                    modal: modalPatient, toggle: togglePatient, modalTitle, method: methodPatient, loading: loadingPatient,
                    validationsPatient, saveUpdateWorkOrder, validHopitalInterfaced, handleBirthDateChange, handleAgeChange,

                    handleDatePatient, handleChangeSocialGender, validPorcentejeSpecial,
                    handleInputChange: handleInputChangePatient, handleSelectValues: handleSelectValuesPatient, handleDate:
                        handleDatePatient, getBirthday, getAge, handleWheel, handleChangeSocialGender,

                    id_gender: formValuesPatient.id_gender, id_state: formValuesPatient.id_state, id_municipality: formValuesPatient.id_municipality,
                    id_blood_type: formValuesPatient.id_blood_type, id_social_gender: formValuesPatient.id_social_gender, id_tax_regime: formValuesPatient.id_tax_regime,
                    id_use_cfdi: formValuesPatient.id_use_cfdi, rfc: formValuesPatient.rfc, type_person: formValuesPatient.type_person, code: formValuesPatient.code,
                    paternal_surname: formValuesPatient.paternal_surname, maternal_surname: formValuesPatient.maternal_surname, name: formValuesPatient.name, birthday: formValuesPatient.birthday,
                    age: formValuesPatient.age, nss: formValuesPatient.nss,
                    curp: formValuesPatient.curp, address: formValuesPatient.address, cp: formValuesPatient.cp, colony: formValuesPatient.colony,
                    phone: formValuesPatient.phone, email: formValuesPatient.email, membership: formValuesPatient.membership, cardnumber: formValuesPatient.cardnumber,
                    new_social_gender: formValuesPatient.new_social_gender, expedient_number: formValuesPatient.expedient_number,
                    listStates, listMunicipalities, listBloodType, listTaxRegime, listUseCfdi: listUseCfdiPatient, listSocialGender: Listsocialgender,

                    handleChangeState: handleChangeStatePatient, handleChangeTypePerson, handleChangeTaxRegime,
                    savePatient: saveCreatePatient, saveUpdate: saveUpdatePatient,

                    isInvoiceService, setIsInvoiceService,
                    viewNewSocialGender, setViewNewSocialGender,
                    scan_ine_check: formValuesPatient.scan_ine_check, setScan_ine_check, handleOnChangeINE, DeleteINE, showClassINE,
                    img64File: formValuesPatient.img64File, handleOnChangeINEU,
                    codeP: formValuesPatient.cp, handleAgeC, handleDateB,
                    matricula_buap: formValuesPatient.matricula_buap,
                    closeModalPatient, listConfiguration, fieldErrors,
                    whatsapp_numbers: formValuesPatient.whatsapp_numbers,
                    handleWhatsappChange, validateWhatsapp,
                    hospitalized: formValuesPatient.hospitalized,

                }
                }
            />
            <ModalDoctor
                nameInputs={nameInputsDoctor}
                addSpecialty={true}
                {
                ...{
                    modal: modalDoctor, toggle: toggleDoctor, handleInputChange: handleInputChangeDoctor, saveCreate: saveCreateDoctor,
                    saveUpdate: saveUpdateDoctor, loading: loadingDoctor, method: methodDoctor, specialties, validaciones: validationsDoctor,
                    id_specialty, name_specialty, name: name_doctor, professional_license, phone: phone_doctor, address: address_doctor,
                    email: email_doctor, isCommercialPartner, saveUpdateWorkOrder, validaciones1,
                    code, listSellers, generateRandomPassword, username, password_microsite, id_seller, closeModalDoctor, whatsapp_doctor, handleWhatsappDoctorChange, validateWhatsappDoctor
                }
                }
            />
            <ModalViewExams
                {
                ...{
                    // ? DATA EXAMS
                    modalViewExamsP,
                    toggleModalViewExams,
                    viewExamsProfile
                }
                }
            />


            <ModalSpecialDiscount
                {
                ...{
                    // ? DIALOG
                    modal: modalSpecialDiscounts,
                    toggle: toggleSpecialDiscount,

                    // ? INPUTS
                    special_discount_code,
                    handleInputChangeSpecialDiscount,
                    percentage,
                    validPorcentejeSpecial,
                    dataPreloaded,
                    handleSelectValuesPreloadedDiscounts,
                    id_preloaded_discount,

                    // ? CONFIGURATION DISCOUNTS
                    isPreloadedApplied,
                    setIsPreloadedApplied,
                    isCodeApplied,
                    setIsCodeApplied,
                    isPercentageApplied,
                    setIsPercentageApplied,
                    handleApplyPreloaded,
                    handleApplyCode,
                    handleApplyPercentage,
                    isAnyApplied,

                    // ? LABCEN
                    viewLabcen,
                    percentageDiscount,
                    handleInputChangeWorkOrder,

                    // ? SELF - APPLIED 
                    listCampaigns,
                    selectedCampaign,
                    handleChangeCampaign,

                    // ? INSAN
                    id_branch,
                    new_price,
                    validatePriceWorkOrder
                }
                }
            />

            <ModalCommonDiscounts
                {
                ...{

                    // ? DIALOG
                    modal: modalCommonDiscount,
                    toggle: toggleCommonDiscount,

                    // ? INPUTS
                    arrayCommonDiscounts,
                    clearDiscount,
                    newDiscount,
                    validPorcentejeSpecial,
                    setValidateCommonDiscountDetail,
                    isEditWorkOrder,
                    validateCommonDiscountDetail
                }
                }
            />

            <ModalQuoter
                {
                ...{
                    // ?  CONFIGURATION  
                    modal: modalQuoter,
                    toggle: toggleModalQuoter,
                    modalTitle,
                    method: methodQuoter,
                    loading: loadingQuoter,
                    handleGetQuoter,
                    code_quoter,
                    date_quoter,
                    listQuoter,
                    handleInputChangeQuoter,
                    validationsQuoter,
                    searchQuoterByCode,
                    enableViewTest,
                    viewTestQuoter,
                    handleViewTest,
                    handleCloseViewTest,
                    id_preloaded_discount
                }
                }
            />


            <ModalRepeatProfile
                {
                ...{
                    // ? REPEAT PROFILE
                    modalRepeatProfile,
                    validationsRepeat,
                    modalTitle,
                    toggleRepeatProfile
                }
                }
            />

            <ModalDevolution
                {
                ...{
                    toggleDevolutions: toggleModalDevolutions,
                    modalTitle,
                    devolutionsState: devolutionsW,
                    modalDevolutions,
                    listTest,
                    number_format,
                    listReturnReason: listDevolutions,
                    handleChangeReturnReason: handleChangeDevolution,
                    validateDevolutions,
                    canceldevolution: handleCancelDevolution,
                    saveReturnReason: saveDevolution,
                    loading,
                    loadingDevolution
                }
                }
            />

            <ModalLiquidacion
                {
                ...{
                    modal: modalPayBills,
                    toggle: toggleModalPayBills,
                    handleInputChangeLiquided: handleInputChangePaymentBills,
                    saveLiquided: savePaymentBill,
                    listPayMethod,
                    loading,
                    validatesaveLiquided: validationsPaymentBills,
                    id_method_liquided,
                    amount_liquided,
                    id_method_pay,
                    amount_liq,
                    percentageDiscount,
                    loadingPayment
                }
                }
            />

            <ModalAuthorize
                {
                ...{
                    modal: modalCancelWorkOrderUpdate,
                    toggle: toggleModalCancellWorkOrderUpdate,
                    user_authorize,
                    password_authorize,
                    id_return_reason_woc,
                    percentage_return,
                    validationsCancelWorkOrder,
                    totalCancellationWorkOrder,
                    loading,
                    listDevolutions,
                    handleInputChangeCancelWorkOrder,
                    handleValidateReturnAmount,
                    saveCancelWorkOrderUpdate,
                    validatePasswordCancell,
                    aunthentication,
                    errors
                }
                }
            />

            <ModalUpdateMethod
                {
                ...{
                    modalPreviewUpdate,
                    toggleModalUpdate,
                    user_method,
                    user_password_method,
                    id_pay_method_method,
                    handleInputChangeMethod,
                    saveUpdateMethod,
                    loading,
                    modalTitle,
                    listPayMethod,
                    validatePassword,
                    aunthentication,
                    loadingUpdateMethod,
                    validPorcentejeSpecial,
                    insan,
                    onSelect,
                    preview,
                    type,
                    onClear,
                    form,
                    setForm,
                    phersu,
                    checkTypeClient,
                    isPayForCompany,
                    AvailablePayMethodByCompany,
                    cedimi

                }
                }
            />
            <ModalCourtesyy
                {
                ...{
                    ModalCourtesy,
                    toggleCourtesy,
                    validatePasswordCortesy,
                    user_method,
                    user_password_method,
                    handleInputChangeMethod,
                    aunthentication,
                    loadingUpdateMethod
                }
                }
            />

            <ModalMassLoadErrors
                modalTitle="Errores de Muestreo"

                {
                ...{
                    modal: modalOpen,
                    toggle: toggleModalErrorMasiveLoad,
                    goNextPage,
                    goPreviousPage,
                    goToPage,
                    actualPage,
                    totalPages,
                    fileReport,
                    downloadMassiveSampligFile,
                    massiveSamplig

                }
                }
            />

            <ModalListDevolution
                {
                ...{ modalDevolution, toggleModalDevolution, historicDevolution, amountDevolution }
                }
            />
            {
                // * DOCTOR
            }
            <Dialog
                header="Información del médico"
                visible={showDoctorDialog}
                style={{ width: "450px" }}
                modal
                onHide={() => setShowDoctorDialog(false)}
            >

                {selectedDoctor && (

                    <div className="doctor-detail">

                        <p><b>Nombre:</b> {selectedDoctor.name}</p>

                        <p><b>Especialidad:</b> {selectedDoctor.name_specialty || "N/A"}</p>

                        <p><b>Correo:</b> {selectedDoctor.email || "No registrado"}</p>

                        <p><b>Teléfono:</b> {selectedDoctor.phone || "N/A"}</p>

                        <p><b>Convenio:</b> {selectedDoctor.isCommercialPartner ? "Sí" : "No"}</p>

                        {selectedDoctor.isCommercialPartner && (
                            <p><b>No. Colegiado:</b> {selectedDoctor.code}</p>
                        )}

                    </div>

                )}

            </Dialog>
            {
                // * CONFIGURATION MODAL ORDER
            }
            <ModalTotalOrder
                {
                ...{

                    // ? DIALOG
                    toggleTotal,
                    modalTotal,

                    // ? CARD 1
                    number_format,
                    totalW,

                    // ? CONFIGURATION DISCOUNT
                    isAnyApplied,
                    isCodeApplied,
                    isPercentageApplied,
                    percentage,
                    isPreloadedApplied,
                    id_preloaded_discount,

                    // ? CONFIGURATION COMMON DISCOUNTS
                    arrayCommonDiscounts,

                    // ? CONFIGURATION PAY METHODS
                    listPayMethods,
                    validPorcentejeSpecial,
                    handleDinamicInputWorkOrder,
                    cedimi,
                    isEditWorkOrder,
                    listPayMethod,
                    checkTypeClient,
                    isPayForCompany,
                    _adminFinance,
                    AvailablePayMethodByCompany,
                    validTotalCredit,
                    _authorized_movement,
                    handleUpdateMethod,
                    handleCourtesy,
                    listPayMethods_valid,
                    showMessageW,
                    handlePayBill,
                    handleGiveChange,
                    handleDeletePayMethod,
                    validButton,
                    handleAddPayMethodInputs,

                    // ? INVOICE
                    id_company,
                    checkInvoice,
                    handleInputChangeWorkOrder,
                    requiere_invoice_patient_update,

                    // ? TOTAL ORDERS
                    showDiscountWarning,
                    showDiscountWarningPay,
                    listTest,
                    loading,
                    showButton,
                    enableBtnSaveWorkOrder,
                    BtnSaveWorkOrder,
                    saveUpdateWorkOrder,
                    saveWorkOrder,
                    cancellWorkOrder,

                    modalPreviewUpdate,
                    isPay,


                    ListOptionsPaymentBy,
                    OptionPaymentByCompany,
                    OptionPaymentByPatient,
                    PlaceHolderOption,
                    handleChangeGeneratePay,


                    toggleStudies,
                    modalStudies,
                    modalPayBills,
                    ModalCourtesy,
                    modalAutorization,

                    insan,
                    _branch_name,


                    percentageDiscount,
                    labcen,
                    buap,
                    sharp,
                    hsjs,
                    arcangeles,

                    // ? COMPANY
                    acceptCompany,
                    setAcceptCompany,
                    setFooterOpen,
                    validate_update_payMethod,
                    phersu,
                    isInvoicePatient


                }
                }
            />
            {
                // * CONFIGURATION STUDIES IN THE ORDER
            }
            <Dialog
                visible={modalStudies}
                onHide={toggleStudies}
                header="Estudios incluidos en la orden"
                draggable={false}
                className="custom-studies-modal"
                modal={false}
                headerStyle={{
                    backgroundColor: '#002940',
                    color: 'white',
                    fontWeight: 'bold',
                }}
                pt={{
                    header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                    content: { style: { paddingLeft: "1px" } }
                }}
            >
                <div className="studies-container">
                    {
                        listTest?.map((item, index) => (
                            <div key={index} className="study-card">

                                <div className="study-icon">
                                    <i className="fa fa-flask"></i>
                                </div>

                                <div className="study-info">
                                    <div className="study-name">
                                        {item.name}
                                    </div>

                                    <div className="study-extra">
                                        {item.specimen_name}
                                    </div>
                                </div>

                            </div>
                        ))
                    }

                </div>
            </Dialog>
            {
                // * ALERT TIME DELIVERY
            }
            {
                showTimeAlert && (
                    <AlertDataTable
                        titleAlert="Tiempo de entrega "
                        visibleAlert={modalTime}
                        onHideAlert={toggleAlert}
                        titleNotLoading="Aceptar"
                        titleDanger="Aceptar"
                        messageAlert="."
                        alert1="."
                        titleAlert1="Debe de seleccionar un tiempo de entrega para esta orden"
                        maskClassName="custom-doctor-mask"
                        newDesingDialog={true}
                        iconNewDialog="fa fa-clock-o f-20"
                    />
                )
            }
            {
                // * ACTIONS DOCTORS
            }
            {
                showDoctorAlert && (
                    <AlertDataTable
                        titleAlert="Doctor duplicado"
                        visibleAlert={modalDoctorN}
                        onHideAlert={toggleDoctorAlert}
                        titleNotLoading="Aceptar"
                        buttonCancell={false}
                        messageAlert="El doctor ya se encuentra en esta orden asignado."
                        alert1={false}
                        titleAlert1={titleDoctor}
                        color={true}
                        headerColor="#0f172a"
                        buttonAcept={false}
                        sizeAlert="medium-dialog-doctor"
                        maskClassName="custom-doctor-mask"
                        newDesingDialog={true}
                        iconNewDialog="fa fa-user-md f-20"
                    />
                )
            }
            {
                showDoctorDelete && (
                    <AlertDataTable
                        titleAlert="Eliminar doctor"
                        visibleAlert={modalDoctorDelete}
                        onHideAlert={toggleDoctorDelete}
                        titleNotLoading="Aceptar"
                        messageAlert="Esta seguro que desea eliminar este doctor?"
                        alert1={true}
                        color={true}
                        headerColor="#0f172a"
                        buttonAcept={true}
                        sizeAlert="medium-dialog-doctor"
                        maskClassName="custom-doctor-mask"
                        actionAcept={confirmDeleteDoctor}
                        titleAlert1={nameDoctorD}
                        buttonCancell={true}
                        titleDanger="Cancelar"
                        newDesingDialog={true}
                        iconNewDialog="fa fa-trash f-20"
                    />
                )
            }
            {
                // * SAVE EDIT ACTIONS
            }
            {
                showActionAlert && (
                    <AlertDataTable
                        titleAlert="Configuración"
                        visibleAlert={modalActions}
                        onHideAlert={toggleActionAlert}
                        titleNotLoading="Aceptar"
                        messageAlert={changes.length === 0 ? "." : "Esta seguro de guardar los siguientes cambios:"}
                        alert1={true}
                        color={true}
                        headerColor="#0f172a"
                        buttonAcept={changes.length === 0 ? false : true}
                        sizeAlert="medium-dialog-doctor"
                        maskClassName="custom-doctor-mask"
                        actionAcept={saveOrder}
                        titleAlert1={
                            changes.length === 0 ? (
                                <div style={{ textAlign: "center", padding: "10px" }}>
                                    <i className="pi pi-spin pi-cog" style={{ fontSize: '2rem' }}></i>

                                    <p style={{ marginTop: "5px", fontSize: "12px" }}>
                                        No hay cambios detectados
                                    </p>
                                </div>
                            ) : (
                                <div className="scroll-changes-table" style={{ maxHeight: "250px", overflowY: "auto" }}>                                    <table className="table table-sm table-bordered" style={{ fontSize: "12px", marginBottom: 0 }}>

                                    <thead style={{ background: "#035583", color: "#fff" }}>
                                        <tr>
                                            <th style={{ width: "25%", color: "#fff" }}>Apartado</th>
                                            <th style={{ width: "37.5%", textAlign: "center", color: "#fff" }}>Anterior</th>
                                            <th style={{ width: "37.5%", textAlign: "center", color: "#fff" }}>Actual</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {changes.map((c, index) => (
                                            <tr key={index}>
                                                <td style={{ padding: "12px 14px" }}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "10px",
                                                            fontWeight: 600,
                                                            color: "#334155"
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                width: "32px",
                                                                height: "32px",
                                                                borderRadius: "8px",
                                                                background: "#f1f5f9",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            <i
                                                                className={c.icon}
                                                                style={{
                                                                    color: "#0f172a",
                                                                    fontSize: "15px"
                                                                }}
                                                            />
                                                        </div>

                                                        <span>{c.field}</span>
                                                    </div>
                                                </td>


                                                {/* <td style={{ fontWeight: "500" }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                        <i className={c.icon} style={{ color: "#0f172a" }}></i>
                                                        {c.field}
                                                    </div>
                                                </td> */}

                                                <td style={{ color: "#0079c7", textAlign: "center" }}>
                                                    {c.old}
                                                </td>

                                                <td style={{ color: "#ff8d00", textAlign: "center" }}>
                                                    {c.new}
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                                </div>
                            )
                        }
                        buttonCancell={true}
                        titleDanger="Cancelar"
                        loadingAlert={loadingSaveConfiguration}
                        titleLoading="Guardando...."
                        actionCancell={true}
                        nameCancell={handleCancelChanges}
                        newDesingDialog={true}
                        iconNewDialog="fa fa-cogs f-20"
                        closable={false}
                    />
                )
            }
            {
                // * INVOICE
            }
            <ModalAutorization
                {
                ...{
                    user_method,
                    user_password_method,
                    handleInputChangeMethod,
                    modalAutorization,
                    toggleModalAutorization,
                    validatePasswordFinance,
                    handleCancelAutorization,
                    configuration_role,
                    handleSendNotificationInvoices,
                    toasts
                }
                }
            />
            {
                showPayAlert && (
                    <AlertDataTable
                        titleAlert="Bloqueo por Factura Vencida"
                        visibleAlert={modalAlert}
                        onHideAlert={toggleAlert}
                        titleNotLoading="Aceptar"
                        titleDanger="Aceptar"
                        messageAlert={
                            isEditA ? (
                                <div>
                                    No se pueden agregar estudios en este orden:
                                    <br />
                                    <strong>Convenio:</strong> {tittleAgreement}
                                    <br />
                                    <strong>Empresa:</strong> {id_company?.label}

                                </div>
                            ) : (
                                <div>
                                    No se pueden realizar admisiones:
                                    <br />
                                    <strong>Convenio:</strong> {tittleAgreement}
                                    <br />
                                    <strong>Empresa:</strong> {id_company?.label}
                                </div>
                            )
                        } alert1={false}
                        titleAlert1="Comuniquese con el personal administrativo."
                    />
                )
            }
            {
                // * DIALOG HISTORIC
            }
            <Dialog
                visible={modalHistoricOrder}
                onHide={toggleHistoric}
                draggable={false}
                modal={false}
                maskClassName="custom-cancell-mask"
                header={
                    <div className="Global-dialog-header">
                        <div className="Global-dialog-header__content">

                            <div className="Global-dialog-icon">
                                <i className="pi pi-history"></i>
                            </div>

                            <div>
                                <div className="Global-dialog-title">
                                    Historico de la orden
                                </div>
                            </div>

                        </div>
                    </div>
                }

                className={`Global-dialog Global-dialog Global-blue Global-xl `}
            >
                <div className='pt-3' >

                    <div
                        style={{
                            background: "#00294012",
                            borderRadius: "12px",
                            padding: "16px",
                            marginBottom: "16px",
                            borderLeft: "5px solid #0f3d5e",
                            boxShadow: "0px 3px 12px rgba(0,0,0,.08)",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "12px"
                        }}
                    >

                        <div>

                            <div
                                style={{
                                    fontSize: "15px",
                                    fontWeight: "600",
                                    color: "#0f3d5e"
                                }}
                            >
                                Historial de cambios del la orden de trabajo
                            </div>

                            <div
                                style={{
                                    fontSize: "12px",
                                    color: "#6c757d",
                                    marginTop: "2px"
                                }}
                            >
                            </div>

                        </div>

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                flexWrap: "wrap"
                            }}
                        >

                            <div
                                style={{
                                    background: "#f4f7fb",
                                    color: "#0f3d5e",
                                    padding: "8px 14px",
                                    borderRadius: "25px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    border: "1px solid #d9e7f2"
                                }}
                            >
                                <i
                                    className="pi pi-user"
                                    style={{
                                        fontSize: "12px"
                                    }}
                                />

                                <span>
                                    Creado por:
                                </span>

                                <span
                                    style={{
                                        color: "#495057",
                                        fontWeight: 500
                                    }}
                                >
                                    {name_create_order ?? "---"}
                                </span>
                            </div>

                            <div
                                style={{
                                    background: "#f4f7fb",
                                    color: "#0f3d5e",
                                    padding: "8px 14px",
                                    borderRadius: "25px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    border: "1px solid #d9e7f2"
                                }}
                            >
                                <i
                                    className="pi pi-calendar"
                                    style={{
                                        fontSize: "12px"
                                    }}
                                />

                                <span>
                                    Fecha:
                                </span>

                                <span
                                    style={{
                                        color: "#495057",
                                        fontWeight: 500
                                    }}
                                >
                                    {fech_create_order ?? "---"}
                                </span>
                            </div>

                            <div
                                style={{
                                    background: "#e8f1f8",
                                    color: "#0f3d5e",
                                    padding: "8px 14px",
                                    borderRadius: "25px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px"
                                }}
                            >
                                <i className="pi pi-clock" />

                                <span>
                                    {dataHistorical?.length ?? 0} movimientos
                                </span>
                            </div>
                        </div>
                    </div>


                    <DataTable
                        value={dataHistorical}
                        paginator
                        rows={8}
                        stripedRows
                        showGridlines
                        className="p-datatable-sm shadow-sm"
                        rowsPerPageOptions={[8, 16, 50, 100]}
                        responsiveLayout="scroll"
                        emptyMessage={
                            <div className="text-center">
                                <img
                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                    style={{ width: "28%" }}
                                    alt="Sin resultados"
                                />
                                <br />
                            </div>
                        }
                    >
                        <Column
                            header="#"
                            body={(row, { rowIndex }) => rowIndex + 1}
                            headerStyle={headerStyle}
                            style={centerStyle}
                        />

                        <Column
                            field="created_information"
                            header="Fecha"
                            sortable
                            headerStyle={headerStyle}
                            style={centerStyle}
                        />

                        <Column
                            field="name_user"
                            header="Usuario"
                            sortable
                            headerStyle={headerStyle}
                            style={centerStyle}
                        />

                        <Column
                            field="field_name"
                            header="Campo"
                            sortable
                            headerStyle={headerStyle}
                            style={centerStyle}
                        />

                        <Column
                            field="original_information"
                            header="Valor anterior"
                            sortable
                            headerStyle={headerStyle}
                            style={centerStyle}

                        />

                        <Column
                            field="updated_information"
                            header="Valor nuevo"
                            sortable
                            headerStyle={headerStyle}
                            style={centerStyle}
                        />

                        <Column
                            field="method"
                            header="Acción"
                            body={methodBody}
                            sortable
                            headerStyle={headerStyle}
                            style={centerStyle}
                        />
                        {
                            validPorcentejeSpecial === insan && (
                                <>
                                    <Column
                                        header="Evidencia"
                                        body={evidenceBody}
                                        headerStyle={headerStyle}
                                        style={centerStyle}
                                    />

                                    <Column
                                        field="observation"
                                        header="Observación"
                                        sortable
                                        headerStyle={headerStyle}
                                        style={centerStyle}
                                    />
                                </>
                            )
                        }
                    </DataTable>
                </div>

            </Dialog>
            {
                // * DIALOG EVIDENCE
            }
            <Dialog
                header={
                    <div className="Global-dialog-header">
                        <div className="Global-dialog-header__content">

                            <div className="Global-dialog-icon">
                                <i className="pi pi-image"></i>
                            </div>

                            <div>
                                <div className="Global-dialog-title">
                                    Evidencia
                                </div>
                            </div>

                        </div>
                    </div>
                }
                className={`Global-dialog Global-dialog Global-blue Global-small-v2 `}
                visible={showEvidence}
                style={{ width: "70vw" }}
                onHide={() => setShowEvidence(false)}
            >
                {isImage && (
                    <img
                        src={evidenceFile}
                        alt="Evidencia"
                        style={{
                            width: "100%",
                            maxHeight: "70vh",
                            objectFit: "contain"
                        }}
                    />
                )}

                {isPdf && (
                    <iframe
                        src={evidenceFile}
                        title="PDF"
                        width="100%"
                        height="700px"
                        style={{ border: 0 }}
                    />
                )}

            </Dialog>

            <CustomAlertDialogGlobal
                visible={customAlert.visible}
                mode={customAlert.mode}
                type={customAlert.type}
                title={customAlert.title}
                message={customAlert.message}
                buttonText={customAlert.buttonText}
                cancelText={customAlert.cancelText}
                onAccept={customAlert.onAccept}
                onCancel={customAlert.onCancel}
            />

            {
                //? ALERT GLOBAL
            }

            <ToastAletGlobal
                visible={showToast}
                type={toastType}
                title={toastTitle}
                message={toastMessage}
                onClose={closeToastAlert}
            />

            <DialogHistoricoHospitalized
                visible={modalHistoricHospitality}
                onHide={toggleHistoricHospitality}
                data={dataHistoricalHospitality}
                patientName={[
                    informationPatient?.name,
                    informationPatient?.paternal_surname,
                    informationPatient?.maternal_surname
                ]
                    .filter(Boolean)
                    .join(" ")
                }

            />

            {
                // ? DIALOG ORDER MEDICAL
            }

            <Dialog
                visible={showMedicalOrderPreview}
                onHide={() => setShowMedicalOrderPreview(false)}
                header={
                    <div className="Global-dialog-header">
                        <div className="Global-dialog-header__content">

                            <div className="Global-dialog-icon">
                                <i className="pi pi-image"></i>
                            </div>

                            <div>
                                <div className="Global-dialog-title">
                                    Visualizar Orden Medica
                                </div>
                            </div>

                        </div>
                    </div>
                }
                className={`Global-dialog Global-dialog Global-blue Global-small-1`}
                modal
                draggable={false}
            >

                <div
                    style={{
                        height: "60vh",
                        width: "100%"
                    }}
                >

                    {
                        valid_medical_order && (
                            <iframe
                                src={`data:application/pdf;base64,${valid_medical_order}`}
                                title="Orden médica"
                                width="100%"
                                height="100%"
                                style={{
                                    border: "none",
                                    borderRadius: "6px"
                                }}
                            />
                        )
                    }

                </div>


                <div className="d-flex justify-content-end align-items-center mt-3" style={{ gap: "8px" }}>

                    {/* ELIMINAR ORDEN MÉDICA EXISTENTE */}
                    <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => {
                            setShowMedicalOrderPreview(false);
                            setShowDeleteMedicalConfirm(true);
                        }}
                    >
                        <i className="fa fa-trash mr-2"></i>
                        Eliminar orden médica
                    </button>


                    {/* CAMBIAR ORDEN MÉDICA */}
                    <label
                        className="btn btn-primary btn-sm mb-0"
                        style={{ cursor: "pointer" }}
                    >
                        <i className="fa fa-upload mr-2"></i>

                        Cambiar orden médica

                        <input
                            type="file"
                            accept="image/*,.pdf"
                            name="medical_order"
                            onChange={(e) => {

                                handleOnChange(e);

                                setShowMedicalOrderPreview(false);
                            }}
                            hidden
                        />
                    </label>

                </div>

            </Dialog>


            {
                // *
            }
            <Dialog
                visible={showDeleteMedicalConfirm}
                onHide={() => {
                    setShowDeleteMedicalConfirm(false);
                    setShowMedicalOrderPreview(true);
                }}
                header={
                    <div className="Global-dialog-header">
                        <div className="Global-dialog-header__content">
                            <div className="Global-dialog-icon">
                                <i className='fa fa-exclamation-triangle' ></i>
                            </div>

                            <div>
                                <div className="Global-dialog-title">
                                    {"Orden médica"}

                                </div>
                            </div>
                        </div>
                    </div>
                }
                className="seller-dialog seller-dialog seller-danger seller-small-v"
                modal
                draggable={false}
                closable={false}
                footer={

                    <>
                        <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={() => {
                                setShowDeleteMedicalConfirm(false);
                                setShowMedicalOrderPreview(true);
                            }}
                            disabled={loadingDelete}
                        >
                            Cancelar
                        </Button>

                        <Button
                            size="sm"
                            color="danger"
                            type="button"
                            onClick={handleDeleteMedical}
                            disabled={loadingDelete}
                        >
                            {loadingDelete ? "Eliminando" ?? "--" : "Eliminar" ?? "---"}
                        </Button>

                    </>

                }
            >

                <div className='pt-2' >
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        marginBottom: "15px"
                    }}>
                        <div style={{
                            backgroundColor: "#ffe6e6",
                            borderRadius: "50%",
                            width: "50px",
                            height: "48px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <AlertTriangle size={28} color="#c92a2a" />
                        </div>

                        <div>
                            <p
                                className="mb-0"
                                style={{
                                    fontSize: "13px",
                                    color: "#0d3b59"
                                }}
                            >
                                Esta acción no se puede deshacer.
                                <br />    <br />
                                ¿Deseas eliminar la orden médica anexada a la orden?

                            </p>
                        </div>
                    </div>



                </div>





            </Dialog>
        </Fragment >
    )
}